import { CandidateGroupAttempt } from './candidate-group-attempt';

export class CandidatesGroupWithMostAttempt {
  assessmentName: string;
  candidateAttemptsDTOs: CandidateGroupAttempt[];

  constructor(stats?: Partial<CandidatesGroupWithMostAttempt>) {
    Object.assign(this, stats);
  }
}
